module.exports = __webpack_public_path__ + "static/media/usage_object.71146aca.png";